import { render, staticRenderFns } from "./CommentsNavigation.vue?vue&type=template&id=bb7021da"
import script from "./CommentsNavigation.vue?vue&type=script&lang=js"
export * from "./CommentsNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports